module.exports = __webpack_public_path__ + "static/image-03-b@2x-fde5a286d1172cd55b02cbb70a54bc74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/deliveroo/image-03-b@2x.jpg
// module id = 358
// module chunks = 3627797113349 20562973939449 33019919093843